/** Composição compacta compartilhada; busca e filtros permanecem controlados por cada domínio. */
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { Separator } from '@/components/ui/separator';
export function KanbanFilterLayout({ title, search, filters, actions, children, className }: {
  title: ReactNode; search: ReactNode; filters: ReactNode; actions: ReactNode; children?: ReactNode; className?: string;
}) {
  return <div className={cn('flex w-full flex-wrap items-center gap-2 sm:gap-3', className)}>
    <div className="flex shrink-0 items-center">{title}</div>{search}
    {/* Filtros em outra linha no celular não deixam um separador isolado. */}
    <Separator orientation="vertical" className="hidden h-5 shrink-0 sm:block" />
    <div className="order-last flex w-full min-w-0 items-center gap-1.5 overflow-x-auto sm:order-none sm:w-auto sm:flex-1 sm:gap-2">{filters}</div>
    <div className="ml-auto flex shrink-0 items-center gap-1">{actions}</div>{children}
  </div>;
}